import React from "react";
import RoutesComponent from "./components/common/RoutesComponent"
import { RecaptchaProvider } from "./config/utils/recaptcha";


const App: React.FC = () => {
  return (
    <div className="App">
      <RecaptchaProvider>
        <RoutesComponent />
      </RecaptchaProvider>
    </div>
  );
};

export default App;
